"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printCustomerLabel = void 0;
const customer_1 = require("./customer");
const POST_MESSAGE_TYPE = 'zebra_print_label';
const printCustomerLabel = (params) => {
    const { customerLabel, orderId, ...customer } = params;
    const customerCode = (0, customer_1.customerToCode)(customer);
    const normalizedCustomerLabel = (0, customer_1.normalizeCustomerLabel)(customerLabel);
    const localPrinterIdAddress = localStorage.getItem('printer_ip_address');
    const ZEBRA_PRINTER_URL = `http://${localPrinterIdAddress}/pstprnt`;
    const zpl = zplBuilder({
        customerCode,
        customerLabel: normalizedCustomerLabel,
        orderId,
        deliveryGroupId: params.deliveryGroupId,
        boxId: params.boxId
    });
    return window.postMessage({
        type: POST_MESSAGE_TYPE,
        zpl,
        url: ZEBRA_PRINTER_URL
    }, '*');
};
exports.printCustomerLabel = printCustomerLabel;
const zplBuilder = ({ customerCode, customerLabel, orderId, deliveryGroupId, boxId }) => {
    return '^XA' +
        '^CF0,20' +
        `^FO30,50^FDB${boxId}^FS` +
        `^FO30,30^FDD${deliveryGroupId}^FS` +
        '^CF0,20' +
        `^FO370,30^FB200,1,0,R,0^FD${orderId}^FS` +
        '^CF0,12' +
        `^FO95,245^FB420,1,0,C,0^FD${customerCode}^FS` +
        '^CF0,40' +
        `^FO105,292^FB400,2,0,C,0^FD${customerLabel}^FS` +
        `^FO216,58^BXN,7,200,26^FD${customerCode}^FS` +
        '^XZ';
};
//# sourceMappingURL=zpl.js.map